/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { ISeries } from 'app/shared/model/series.model';

export interface IInstance {
  id?: string;
  sopInstanceUid?: string | null;
  instanceNumber?: number | null;
  sopClassUid?: string | null;
  patientOrientation?: string | null;
  mediaStorageSopInstanceUid?: string | null;
  transferSyntaxUid?: string | null;
  acquisitionDateTime?: dayjs.Dayjs | null;
  imageType?: string | null;
  pixelSpacing?: number | null;
  imageOrientation?: string | null;
  imagePosition?: string | null;
  sliceThickness?: number | null;
  sliceLocation?: number | null;
  windowCenter?: string | null;
  windowWidth?: string | null;
  xrayTubeCurrent?: number | null;
  exposureTime?: number | null;
  kvp?: string | null;
  contentDateTime?: dayjs.Dayjs | null;
  columns?: number | null;
  rows?: number | null;
  photometricInterpretation?: number | null;
  bitsAllocated?: number | null;
  bitsStored?: number | null;
  pixelRepresentation?: number | null;
  highBit?: number | null;
  imageOrientationPatient?: string | null;
  imagePositionPatient?: string | null;
  frameOfReferenceUid?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  imageObservation?: string | null;
  series?: ISeries;
}

export const defaultValue: Readonly<IInstance> = {
  active: false,
};
